/**
 * The `email-index` TanStack Query key prefix, in a zero-dependency module.
 *
 * Several light cache hooks (metadata, mark-read, membership) need this literal
 * but deliberately avoid importing it from `email-list-panel-utils` (410 lines
 * of list UI, provider icons) just to read one string. Importing it from here
 * keeps their transitive graph free of that UI bundle.
 */
export const EMAIL_INDEX_KEY = 'email-index';
